import React from 'react';
import './Icon.css';

// Common icon paths from Adobe Spectrum
const iconPaths = {
  // UI Icons
  'chevron-down': 'M5 6.5L1.5 3 .8 3.7 5 7.9l4.2-4.2-.7-.7L5 6.5z',
  'chevron-up': 'M5 3.5L8.5 7l.7-.7L5 2.1.8 6.3l.7.7L5 3.5z',
  'chevron-left': 'M3.5 5L7 1.5l-.7-.7L2.1 5l4.2 4.2.7-.7L3.5 5z',
  'chevron-right': 'M6.5 5L3 1.5l.7-.7L7.9 5 3.7 9.2l-.7-.7L6.5 5z',
  'cross': 'M9.2.7 8.5 0 5 3.5 1.5 0 .8.7 4.3 5 .8 9.3l.7.7L5 6.5 8.5 10l.7-.7L5.7 5 9.2.7z',
  'checkmark': 'M3.5 9.5a.999.999 0 0 1-.774-.368l-2.45-3a1 1 0 1 1 1.548-1.264L3.5 7.159l4.676-5.291a1 1 0 0 1 1.548 1.264l-5.45 6a.999.999 0 0 1-.774.368z',
  'alert': 'M5 0C2.25 0 0 2.25 0 5s2.25 5 5 5 5-2.25 5-5S7.75 0 5 0zM4 3h2v4H4V3zm0 5h2v1H4V8z',
  'info': 'M5 0C2.25 0 0 2.25 0 5s2.25 5 5 5 5-2.25 5-5S7.75 0 5 0zM4 3h2v1H4V3zm0 2h2v3H4V5z',
  'search': 'M8.5 7.5L6.1 5.1c.4-.7.6-1.5.6-2.4C6.7 1.2 5.5 0 4 0S1.3 1.2 1.3 2.7s1.2 2.7 2.7 2.7c.9 0 1.7-.2 2.4-.6l2.4 2.4.7-.7zM4 4.7c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z',
  'settings': 'M9.5 5.5h-1.1c-.1-.4-.3-.8-.5-1.1l.8-.8-.7-.7-.8.8c-.3-.2-.7-.4-1.1-.5V1.5h-1v1.1c-.4.1-.8.3-1.1.5l-.8-.8-.7.7.8.8c-.2.3-.4.7-.5 1.1H1.5v1h1.1c.1.4.3.8.5 1.1l-.8.8.7.7.8-.8c.3.2.7.4 1.1.5v1.1h1V8.9c.4-.1.8-.3 1.1-.5l.8.8.7-.7-.8-.8c.2-.3.4-.7.5-1.1h1.1v-1zM5 7c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z',
  'add': 'M5 0C2.2 0 0 2.2 0 5s2.2 5 5 5 5-2.2 5-5S7.8 0 5 0zM7.5 5.5h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1z',
  'remove': 'M5 0C2.2 0 0 2.2 0 5s2.2 5 5 5 5-2.2 5-5S7.8 0 5 0zM7.5 5.5h-5v-1h5v1z',
  'edit': 'M9.3 1.7L8.3.7c-.4-.4-1-.4-1.4 0L1.5 6.1v2.4h2.4l5.4-5.4c.4-.4.4-1 0-1.4zM2.5 7.5v1h1l4.6-4.6-1-1L2.5 7.5z',
  'delete': 'M7 1V0H3v1H0v1h1v7c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V2h1V1H7zM4 1h2v0H4v0zm4 8H2V2h6v7z M3 3h1v5H3V3z M6 3h1v5H6V3z',
  'copy': 'M8 0H2C1.4 0 1 .4 1 1v6h1V1h6V0z M9 2H4c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h5c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1zM9 9H4V3h5v6z',
  'folder': 'M9 2H5.4L4.6 1.2c-.2-.2-.4-.2-.6-.2H1C.4 1 0 1.4 0 2v6c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1zM9 8H1V2h2.4l.8.8H9v5z',
  'home': 'M5 .5L0 4v5.5h3V7h4v2.5h3V4L5 .5zM9 8.5H7V6H3v2.5H1V4.5L5 1.5 9 4.5v4z',
  'star': 'M5 0L3.8 3.1H0l3.1 2.3L1.9 8.5 5 6.2l3.1 2.3L6.9 5.4 10 3.1H6.2L5 0z',
  'heart': 'M5 9.5c-.1 0-.3-.1-.4-.2C3.4 8.4 0 5.4 0 3.5 0 1.6 1.6 0 3.5 0S7 1.6 7 3.5c0 1.9-3.4 4.9-4.6 5.8-.1.1-.3.2-.4.2z',
  'bookmark': 'M2 0v10l3-2 3 2V0H2z',
  'tag': 'M8.5 0H5.2L0 5.2 4.8 10 10 4.8V1.5L8.5 0zM8.5 1.5v2.8L4.8 8.5 1.5 5.2 5.2 1.5h3.3z M7.5 3.5c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z',
  'link': 'M7.5 2.5h-2v1h2c.8 0 1.5.7 1.5 1.5S8.3 6.5 7.5 6.5h-2v1h2c1.4 0 2.5-1.1 2.5-2.5S8.9 2.5 7.5 2.5z M2.5 6.5h2v-1h-2C1.7 5.5 1 4.8 1 4s.7-1.5 1.5-1.5h2v-1h-2C1.1 1.5 0 2.6 0 4s1.1 2.5 2.5 2.5z M3 3.5h4v1H3v-1z',
  'calendar': 'M9 1V0H8v1H2V0H1v1H0v8h10V1H9zM9 8H1V3h8v5z M2 4h1v1H2V4z M4 4h1v1H4V4z M6 4h1v1H6V4z M8 4h1v1H8V4z M2 6h1v1H2V6z M4 6h1v1H4V6z M6 6h1v1H6V6z',
  'clock': 'M5 0C2.2 0 0 2.2 0 5s2.2 5 5 5 5-2.2 5-5S7.8 0 5 0zM5 9C2.8 9 1 7.2 1 5S2.8 1 5 1s4 1.8 4 4-1.8 4-4 4z M5 2v3.4l2.3 1.4-.8 1.3L4 6.5V2h1z',
  'user': 'M5 0C3.3 0 2 1.3 2 3s1.3 3 3 3 3-1.3 3-3S6.7 0 5 0zM5 5C3.9 5 3 4.1 3 3s.9-2 2-2 2 .9 2 2S6.1 5 5 5z M9 10H1c0-2.2 1.8-4 4-4s4 1.8 4 4z',
  'users': 'M3.5 0C2.1 0 1 1.1 1 2.5S2.1 5 3.5 5 6 3.9 6 2.5 4.9 0 3.5 0zM3.5 4C2.7 4 2 3.3 2 2.5S2.7 1 3.5 1 5 1.7 5 2.5 4.3 4 3.5 4z M7 8H0c0-1.7 1.3-3 3-3h1c1.7 0 3 1.3 3 3z M9.5 1C8.7 1 8 1.7 8 2.5S8.7 4 9.5 4 11 3.3 11 2.5 10.3 1 9.5 1z M10 9H8c0-.8-.3-1.5-.8-2h.3c1.4 0 2.5 1.1 2.5 2.5z',
  'mail': 'M10 2H0v6h10V2zM9 3L5 6 1 3h8zM1 7V3.5l4 3 4-3V7H1z',
  'phone': 'M2.4 0C1.1 0 0 1.1 0 2.4v5.2C0 8.9 1.1 10 2.4 10h5.2c1.3 0 2.4-1.1 2.4-2.4V2.4C10 1.1 8.9 0 7.6 0H2.4zM7.6 9H2.4C1.6 9 1 8.4 1 7.6V2.4C1 1.6 1.6 1 2.4 1h5.2C8.4 1 9 1.6 9 2.4v5.2C9 8.4 8.4 9 7.6 9z M3 7h4v1H3V7z',
  'location': 'M5 0C2.2 0 0 2.2 0 5c0 3.5 5 5 5 5s5-1.5 5-5c0-2.8-2.2-5-5-5zM5 7C3.9 7 3 6.1 3 5s.9-2 2-2 2 .9 2 2S6.1 7 5 7z',
  'globe': 'M5 0C2.2 0 0 2.2 0 5s2.2 5 5 5 5-2.2 5-5S7.8 0 5 0zM8.9 4.5H7.1c-.1-1.2-.4-2.3-.8-3.2 1.1.5 1.9 1.4 2.6 2.5.1.2.1.5 0 .7z M6.2 4.5H3.8c.1-1.5.5-2.8 1.2-2.8s1.1 1.3 1.2 2.8z M2.7 1.3c-.4.9-.7 2-.8 3.2H.1c.7-1.6 2-2.8 3.6-3.2z M.1 5.5h1.8c.1 1.2.4 2.3.8 3.2C1.6 8.2.8 7 .1 5.5z M3.8 5.5h2.4c-.1 1.5-.5 2.8-1.2 2.8S3.9 7 3.8 5.5z M7.3 8.7c.4-.9.7-2 .8-3.2h1.8c-.7 1.5-1.5 2.7-2.6 3.2z',
  'download': 'M5 0v6.5L3.5 5 2.8 5.7 5 7.9l2.2-2.2-.7-.7L5 6.5V0H5z M0 8v1h10V8H0z',
  'upload': 'M5 7.9V1.4L6.5 2.9l.7-.7L5 0 2.8 2.2l.7.7L5 1.4v6.5H5z M0 8v1h10V8H0z',
  'share': 'M8 0C6.9 0 6 .9 6 2c0 .2 0 .4.1.6L3.4 4.2C3 3.8 2.5 3.5 2 3.5 .9 3.5 0 4.4 0 5.5S.9 7.5 2 7.5c.5 0 1-.3 1.4-.7l2.7 1.6c-.1.2-.1.4-.1.6 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2c-.5 0-1 .3-1.4.7L3.9 6.1c.1-.2.1-.4.1-.6s0-.4-.1-.6l2.7-1.6C6.9 3.7 7.4 4 8 4c1.1 0 2-.9 2-2S9.1 0 8 0z',
  'print': 'M8 0H2v2h6V0z M9 3H1C.4 3 0 3.4 0 4v3h2v3h6V7h2V4c0-.6-.4-1-1-1zM7 9H3V6h4v3z M8 5.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5z',
  'refresh': 'M5 0C2.2 0 0 2.2 0 5h1.5L0 7.5 2.5 5H1c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4v1c2.8 0 5-2.2 5-5S7.8 0 5 0z',
  'undo': 'M5 0C2.2 0 0 2.2 0 5h1.5L0 7.5 2.5 5H1c0-2.2 1.8-4 4-4s4 1.8 4 4H8c0-2.8-2.2-5-5-5z',
  'redo': 'M5 0c2.8 0 5 2.2 5 5H8.5L10 7.5 7.5 5H9c0-2.2-1.8-4-4-4S1 2.8 1 5H0c0-2.8 2.2-5 5-5z'
};

const Icon = ({ 
  name, 
  size = 'm', 
  color, 
  className = '',
  ...props 
}) => {
  const iconPath = iconPaths[name];
  
  if (!iconPath) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  const sizeClass = `spectrum-icon--size-${size}`;
  const classes = `spectrum-icon ${sizeClass} ${className}`.trim();

  return (
    <svg 
      className={classes}
      viewBox="0 0 10 10"
      style={color ? { color } : undefined}
      aria-hidden="true"
      {...props}
    >
      <path d={iconPath} fill="currentColor" />
    </svg>
  );
};

export default Icon; 